import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
export const PlatformDashboardFloatingAlertStore = FloatingAlertStore.newFloatingAlertStore();